"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeSixService = exports.TypeSevenService = exports.TypeFourService = exports.TypeFiveService = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));
var _RadioButtons = _interopRequireDefault(require("../RadioButtons/RadioButtons"));
var _Dropdown = _interopRequireDefault(require("../Dropdown/Dropdown"));
var _MultiselectDropdown = _interopRequireDefault(require("../MultiselectDropdown/MultiselectDropdown"));
var _ButtonsContainer = _interopRequireDefault(require("./ButtonsContainer"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DateFormatter = _interopRequireDefault(require("../../common/Formatters/DateFormatter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.ServiceBox {\n  padding: 0;\n  min-height: 200px;\n  display: flex;\n  flex-flow: column;\n  border: solid 1px #e8e8e8; }\n  .ServiceBox .ServiceBox-Header {\n    display: flex;\n    flex-flow: column nowrap;\n    gap: 16px; }\n  .ServiceBox .ServiceBox-CheckBoxes {\n    margin-top: 24px; }\n  .ServiceBox .ServiceBox-Content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    padding: 16px 16px 0 16px; }\n    .ServiceBox .ServiceBox-Content .ServiceBox-Title {\n      color: #e41b13; }\n    .ServiceBox .ServiceBox-Content .ServiceBox-Body {\n      display: flex;\n      flex-flow: column;\n      margin-top: 24px;\n      gap: 24px; }\n      .ServiceBox .ServiceBox-Content .ServiceBox-Body .ServiceBox-Form {\n        display: flex;\n        gap: 30px; }\n        .ServiceBox .ServiceBox-Content .ServiceBox-Body .ServiceBox-Form .ServiceBox-CheckBoxes {\n          margin-top: 0; }\n      .ServiceBox .ServiceBox-Content .ServiceBox-Body .ServiceBox-QueryTitle {\n        font-size: 14px;\n        font-weight: bold; }\n      .ServiceBox .ServiceBox-Content .ServiceBox-Body .bx--link {\n        align-self: flex-start; }\n      .ServiceBox .ServiceBox-Content .ServiceBox-Body .bx--link:focus {\n        outline: none; }\n    .ServiceBox .ServiceBox-Content .ServiceBox-Description p {\n      font-size: 14px;\n      line-height: 1.29;\n      color: #4c4c4c;\n      padding-right: 8px; }\n  .ServiceBox .ServiceBox-BtnsContainer {\n    display: flex;\n    margin-top: auto; }\n  .ServiceBox .checkbox {\n    margin-bottom: 0; }\n  .ServiceBox .ServiceBox-extended-margin {\n    margin-left: -16px;\n    margin-right: -16px; }\n  .ServiceBox .ServiceBox-Btn {\n    background-color: #a8a8a8;\n    display: flex;\n    width: 100%; }\n    .ServiceBox .ServiceBox-Btn a,\n    .ServiceBox .ServiceBox-Btn p {\n      padding: 16px;\n      color: #fff;\n      display: block;\n      text-decoration: none;\n      font-size: 14px;\n      line-height: 1.5;\n      flex: 1;\n      cursor: pointer; }\n    .ServiceBox .ServiceBox-Btn:hover {\n      background: #4c4c4c; }\n  .ServiceBox .ServiceBox-Btn__dark {\n    background-color: #4c4c4c; }\n    .ServiceBox .ServiceBox-Btn__dark:hover {\n      background-color: #000000; }\n  .ServiceBox .ServiceBox-Btn__red:hover {\n    background-color: #e41b13; }\n  .ServiceBox .ServiceBox-Btn__disabled {\n    background: #d4d4d4;\n    border-color: #d4d4d4;\n    color: #ffffff; }\n    .ServiceBox .ServiceBox-Btn__disabled p:hover {\n      cursor: not-allowed;\n      background: #a8a8a8; }\n\n.ServiceBox-Subscribed {\n  background-color: #f4f4f4; }\n";
  const fileName = "Helper_ServiceSubscriptionBox";
  const element = document.querySelector("style[data-sass-component='Helper_ServiceSubscriptionBox']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const TypeFourService = _ref => {
  let {
    checkBoxOptions,
    onSave,
    translate
  } = _ref;
  const [checkBoxes, setCheckBoxes] = (0, _react.useState)([...checkBoxOptions] || []);
  const onCheckboxSave = () => {
    onSave(checkBoxes);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "ServiceBox-CheckBoxes"
  }, checkBoxes.map((checkBox, i) => /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    key: checkBox.id,
    id: checkBox.id,
    label: checkBox.name,
    value: checkBox.isSubscribed,
    onChange: (e, value) => {
      let checkBoxIndex = checkBoxes.findIndex(e => e.id === checkBox.id);
      checkBoxes[checkBoxIndex] = {
        ...checkBoxes[checkBoxIndex],
        isSubscribed: value
      };
      let updatedState = [...checkBoxes];
      setCheckBoxes(updatedState);
    }
  }))), /*#__PURE__*/_react.default.createElement(_ButtonsContainer.default, {
    className: 'ServiceBox-extended-margin',
    type: 4,
    isSubscribed: checkBoxes.some(e => e.isSubscribed),
    isCancelled: checkBoxes.some(e => e.isCancelled),
    onSave: onCheckboxSave,
    translate: translate
  }));
};
exports.TypeFourService = TypeFourService;
TypeFourService.propTypes = {
  checkBoxes: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    name: _propTypes.default.string,
    isSubscribed: _propTypes.default.bool,
    isCancelled: _propTypes.default.bool
  })),
  onSave: _propTypes.default.func.isRequired,
  translate: _propTypes.default.func.isRequired
};
const TypeFiveService = _ref2 => {
  let {
    name,
    isSubscribed,
    isCancelled,
    radioItemsOptions,
    selectedValueOption,
    checkBoxOptions,
    translate,
    onSave
  } = _ref2;
  const [radioItems] = (0, _react.useState)(radioItemsOptions || []);
  const [selectedValue, setSelectedValue] = (0, _react.useState)(selectedValueOption || '');
  const [checkBoxes, setCheckBoxes] = (0, _react.useState)(checkBoxOptions || []);
  const onStateSave = () => {
    onSave(selectedValue, checkBoxes);
  };
  (0, _react.useEffect)(() => {
    if (selectedValue) {
      if (selectedValue === 'None') {
        let resetedCheckBoxes = checkBoxes.map(e => ({
          ...e,
          value: false
        }));
        setCheckBoxes(resetedCheckBoxes);
      }
    }
  }, [selectedValue]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "ServiceBox-Body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ServiceBox-Form"
  }, radioItems && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "ServiceBox-RadioButton"
  }, /*#__PURE__*/_react.default.createElement(_RadioButtons.default, {
    name: name,
    items: radioItems,
    selectedValue: selectedValue,
    onChange: value => setSelectedValue(value)
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "ServiceBox-CheckBoxes"
  }, checkBoxes.map((box, i) => /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    disabled: selectedValue == 'None',
    key: i,
    id: `${box.value}${i}`,
    label: box.label,
    value: box.value,
    onChange: (e, value) => {
      let checkBoxIndex = checkBoxes.findIndex(e => e.label === box.label);
      checkBoxes[checkBoxIndex] = {
        ...checkBoxes[checkBoxIndex],
        value: value
      };
      let updatedState = [...checkBoxes];
      setCheckBoxes(updatedState);
    }
  })))))), /*#__PURE__*/_react.default.createElement(_ButtonsContainer.default, {
    className: 'ServiceBox-extended-margin',
    type: 5,
    isSubscribed: isSubscribed,
    isCancelled: isCancelled,
    onSave: onStateSave,
    translate: translate
  }));
};
exports.TypeFiveService = TypeFiveService;
TypeFiveService.propTypes = {
  name: _propTypes.default.string.isRequired,
  isSubscribed: _propTypes.default.bool,
  isCancelled: _propTypes.default.bool,
  radioItemsOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.string,
    label: _propTypes.default.string
  })),
  selectedValue: _propTypes.default.string,
  checkBoxOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.bool,
    label: _propTypes.default.string,
    id: _propTypes.default.number
  })),
  translate: _propTypes.default.func.isRequired,
  onSave: _propTypes.default.func.isRequired
};
const TypeSixService = _ref3 => {
  let {
    translate,
    dropdownConfigs,
    onDropdownChange,
    isSubscribed,
    isCancelled,
    onSubscribe,
    onUnsubscribe,
    onManage,
    onSave,
    cancelDate
  } = _ref3;
  const [selectedValues, setSelectedValues] = (0, _react.useState)(dropdownConfigs.map(() => null));
  const [touched, setTouched] = (0, _react.useState)(dropdownConfigs.map(() => false));
  const [isFormValid, setIsFormValid] = (0, _react.useState)(false);
  const handleDropdownChange = (index, selectedItem, name) => {
    const updatedValues = [...selectedValues];
    updatedValues[index] = selectedItem;
    setSelectedValues(updatedValues);
    onDropdownChange(name, selectedItem);
    const updatedTouched = [...touched];
    updatedTouched[index] = true;
    setTouched(updatedTouched);
  };
  (0, _react.useEffect)(() => {
    const allRequiredSelected = dropdownConfigs.every((config, index) => {
      if (config.required) {
        return selectedValues[index] !== null;
      }
      return true;
    });
    setIsFormValid(allRequiredSelected);
  }, [selectedValues, dropdownConfigs]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-margin-03-top"
  }, dropdownConfigs.map((config, index) => /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
    key: index,
    id: `${config.id}-dropdown`,
    label: config.name,
    items: config.items,
    value: selectedValues[index],
    onChange: (event, item) => handleDropdownChange(index, item, config.name),
    placeholder: config.placeholder,
    translate: translate,
    required: config.required,
    helperText: config.helperText,
    invalidText: isSubscribed ? null : !touched[index] && config.required && selectedValues[index] === null ? translate('form.input.error.empty') : null,
    narrow: config.narrow,
    inline: config.inline,
    disabled: isSubscribed
  }))), isCancelled ? /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-16"
  }, translate('subscriptionBox.cancelDate', {
    cancelDate: _DateFormatter.default.formatForTable(cancelDate)
  })) : null, /*#__PURE__*/_react.default.createElement(_ButtonsContainer.default, {
    className: 'ServiceBox-extended-margin',
    type: 6,
    isSubscribed: isSubscribed,
    isCancelled: isCancelled,
    onManage: onManage,
    onSubscribe: onSubscribe,
    onUnsubscribe: onUnsubscribe,
    onSave: onSave,
    translate: translate,
    isFormValid: isFormValid
  }));
};
exports.TypeSixService = TypeSixService;
TypeSixService.propTypes = {
  dropdownConfigs: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    name: _propTypes.default.string,
    items: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string,
      label: _propTypes.default.string
    })).isRequired,
    selectedValue: _propTypes.default.shape({
      id: _propTypes.default.string,
      label: _propTypes.default.string
    }),
    required: _propTypes.default.bool,
    placeholder: _propTypes.default.string,
    helperText: _propTypes.default.string,
    invalidText: _propTypes.default.string,
    narrow: _propTypes.default.bool,
    inline: _propTypes.default.bool
  })).isRequired,
  translate: _propTypes.default.func,
  onSave: _propTypes.default.func,
  isSubscribed: _propTypes.default.bool,
  isCancelled: _propTypes.default.bool,
  onManage: _propTypes.default.func,
  onSubscribe: _propTypes.default.func,
  onUnsubscribe: _propTypes.default.func,
  cancelDate: _propTypes.default.string
};
const TypeSevenService = _ref4 => {
  let {
    translate,
    dropdownConfigs,
    onDropdownChange,
    isSubscribed,
    isCancelled,
    onSubscribe,
    onUnsubscribe,
    onManage,
    onSave,
    cancelDate,
    updateSubscription,
    resetDropdown
  } = _ref4;
  const [dropdownSelectedItems, setDropdownSelectedItems] = (0, _react.useState)(dropdownConfigs.map(config => config.items.map(item => ({
    ...item
  }))));
  const [isFormValid, setIsFormValid] = (0, _react.useState)(false);
  const [openStates, setOpenStates] = (0, _react.useState)(dropdownConfigs.map(() => false));
  const toggleOpen = (index, newIsOpen) => {
    const newOpenStates = [...openStates];
    newOpenStates[index] = newIsOpen;
    setOpenStates(newOpenStates);
  };
  const handleDropdownChange = (index, name, updatedItems) => {
    const newDropdownSelectedItems = [...dropdownSelectedItems];
    newDropdownSelectedItems[index] = updatedItems;
    setDropdownSelectedItems(newDropdownSelectedItems);
    // Collect all active (selected) items for this dropdown
    const selectedItems = updatedItems.filter(item => item.active);
    onDropdownChange(name, selectedItems);
  };
  (0, _react.useEffect)(() => {
    const allRequiredSelected = dropdownConfigs.every((config, index) => {
      if (config.required) {
        return dropdownSelectedItems[index].some(item => item.active);
      }
      return true;
    });
    setIsFormValid(allRequiredSelected);
  }, [dropdownSelectedItems, dropdownConfigs]);
  (0, _react.useEffect)(() => {
    if (!resetDropdown) return;
    setDropdownSelectedItems(dropdownConfigs.map(config => config.items.map(item => ({
      ...item
    }))));
    setOpenStates(dropdownConfigs.map(() => false));
  }, [resetDropdown, dropdownConfigs]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-margin-03-top"
  }, dropdownConfigs.map((config, index) => /*#__PURE__*/_react.default.createElement(_MultiselectDropdown.default, {
    key: index,
    id: `${config.id}-dropdown`,
    isOpen: openStates[index],
    toggle: newIsOpen => toggleOpen(index, newIsOpen),
    label: config.name,
    items: dropdownSelectedItems[index],
    onClickItem: (event, item, updatedItems) => handleDropdownChange(index, config.name, updatedItems),
    required: config.required,
    invalidText: config.required && !dropdownSelectedItems[index].some(item => item.active) ? translate('form.input.error.empty') : null,
    disabled: isCancelled
  }))), isCancelled ? /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-16"
  }, translate('subscriptionBox.cancelDate', {
    cancelDate: _DateFormatter.default.formatForTable(cancelDate)
  })) : null, /*#__PURE__*/_react.default.createElement(_ButtonsContainer.default, {
    className: 'ServiceBox-extended-margin',
    type: 7,
    isSubscribed: isSubscribed,
    isCancelled: isCancelled,
    onManage: onManage,
    onSubscribe: onSubscribe,
    onUnsubscribe: onUnsubscribe,
    onSave: isFormValid ? onSave : null,
    translate: translate,
    isFormValid: isFormValid,
    updateSubscription: updateSubscription
  }));
};
exports.TypeSevenService = TypeSevenService;
TypeSevenService.propTypes = {
  dropdownConfigs: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    name: _propTypes.default.string,
    items: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string,
      label: _propTypes.default.string
    })).isRequired,
    selectedValue: _propTypes.default.shape({
      id: _propTypes.default.string,
      label: _propTypes.default.string
    }),
    required: _propTypes.default.bool,
    invalidText: _propTypes.default.string,
    isOpen: _propTypes.default.bool,
    toggle: _propTypes.default.func
  })).isRequired,
  translate: _propTypes.default.func,
  onSave: _propTypes.default.func,
  isSubscribed: _propTypes.default.bool,
  isCancelled: _propTypes.default.bool,
  onManage: _propTypes.default.func,
  onSubscribe: _propTypes.default.func,
  onUnsubscribe: _propTypes.default.func,
  cancelDate: _propTypes.default.string
};